// extracted by mini-css-extract-plugin
export default {"content":"VzPzONbtUyXG3FPsh9u5","delete-project":"dW5_CQj5zaJTXlX56f_w"};